// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { MainButtonInput } from "../../../mainComponent/mainButtonInput";
// import { MainInput } from "../../../mainComponent/mainInput";
// import { MainSelect } from '../../../mainComponent/mainSelect';
// import AuthApi from "../../../services/AuthApi";
// import { useRecoilState } from "recoil";
// import { setDoctorId } from "../../../recoil/atom/setDoctorId";
// import EducationalApi from "../../../services/EducationalApi";

// export default function CreateForm(props) {
//     //for show otp input
//     const { mobile, _id } = props;
//     const [isError, setIsError] = useState('');
//     const [error, setError] = useState(false);
//     const [DoctorId] = useRecoilState(setDoctorId);
//     const [drspecialization, setDrSpecialization] = useState(null)
//     const [specialization, setSpecialization] = useState('')
//     const [data, setData] = useState(
//         {
//             password: '',
//             confirmPassword: ''
//         }
//     );
//     const { signUp } = AuthApi();
//     const { fetchDrSpecialization } = EducationalApi();
//     const navigate = useNavigate();

//     useEffect(() => {
//         fetchSpecializations()
//     }, [])

//     const fetchSpecializations = () => {
//         fetchDrSpecialization()
//             .then((res) => {
//                 setDrSpecialization(res);
//             })
//     }

//     const handleChange = (event) => {
//         const { name, value } = event.target;
//         setData({ ...data, [name]: value });
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         const password = data.password.trim();
//         const confirmPassword = data.confirmPassword.trim();
//         if (mobile.length < 10 || !/^\d+$/.test(mobile)) {
//             setIsError('Invalid mobile number');
//             return;
//         }
//         if (password === '' || confirmPassword === '') {
//             setIsError('Password fields cannot be empty');
//             return;
//         }

//         if (password !== confirmPassword) {
//             alert('Passwords do not match');
//             return;
//         }
//         if (specialization === '') {
//             setIsError('Select Specialization');
//             return;
//         }
//         const bodyData = {
//             specialization: specialization,
//             mobile: mobile,
//             password: password,
//             _id: _id
//         };
//         signUp(bodyData)
//             .then(response => {
//                 if (response.data.message) {
//                     setError('Sign up failed: ' + response.data.message);
//                 } else {
//                     const doctorId = response.data._id;
//                     navigate(`/newdoctor/${doctorId}/addnewdoctor`);
//                 }
//             })
//             .catch(err => {
//                 console.error('Sign-up error:', err);
//                 setError('An error occurred during sign-up');
//             });
//     };

//     return (
//         <>
//             <div className="col-md-12" align='left'>
//                 {error === true ? <div className="validation mb-2 ml-3">
//                     Mobile number already exist login to continue
//                 </div>
//                     : null}
//             </div>

//             <lable className="mb-2 font_weight">Enter MPIN</lable>
//             <div className="col-md-12">
//                 <MainInput
//                     type="password"
//                     name="password"
//                     maxLength={6}
//                     pattern="[+-]?\d+(?:[.,]\d+)?"
//                     onChange={handleChange}
//                     placeholder="New MPIN"
//                     required
//                 >
//                 </MainInput>
//             </div>

//             <lable className="mb-2 font_weight">Confirm MPIN</lable>
//             <div className="col-md-12">
//                 <MainInput
//                     type="password"
//                     name="confirmPassword"
//                     maxLength={6}
//                     pattern="[+-]?\d+(?:[.,]\d+)?"
//                     onChange={handleChange}
//                     placeholder="Confirm MPIN"
//                     required>
//                 </MainInput>
//             </div>
//             <lable className="mb-2 fontSize">Specialization</lable>
//             <div className="col-md-12 mb-2">
//                 <MainSelect
//                     name="specialization"
//                     className="form-control"
//                     value={specialization}
//                     onChange={(e) => setSpecialization(e.target.value)}>
//                     <option>Select specialization</option>
//                     {drspecialization ?
//                         <>
//                             {drspecialization && drspecialization.map((spe, index) => (
//                                 <option className="form-control" key={index}>{spe.specialization}</option>
//                             ))}
//                         </>
//                         : null}
//                 </MainSelect>
//             </div>
//             <div className="mt-2">
//                 <MainButtonInput onClick={handleSubmit}>Login</MainButtonInput>
//             </div>
//             {isError !== '' ? <div className="validation mt-3 ml-3">
//                 {isError}
//             </div>
//                 : null}
//         </>
//     )
// }
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { MainButtonInput } from "../../../mainComponent/mainButtonInput";
// import { MainInput } from "../../../mainComponent/mainInput";
// import { MainSelect } from '../../../mainComponent/mainSelect';
// import AuthApi from "../../../services/AuthApi";
// import { useRecoilState } from "recoil";
// import { setDoctorId } from "../../../recoil/atom/setDoctorId";
// import EducationalApi from "../../../services/EducationalApi";

// export default function CreateForm(props) {
//     //for show otp input
//     const { mobile, _id } = props;
//     const [isError, setIsError] = useState('');
//     const [error, setError] = useState(false);
//     const [DoctorId] = useRecoilState(setDoctorId);
//     const [drspecialization, setDrSpecialization] = useState(null)
//     const [specialization, setSpecialization] = useState('')
//     const [data, setData] = useState(
//         {
//             password: '',
//             confirmPassword: ''
//         }
//     );
//     const { signUp } = AuthApi();
//     const { fetchDrSpecialization } = EducationalApi();
//     const navigate = useNavigate();

//     useEffect(() => {
//         fetchSpecializations()
//     }, [])

//     const fetchSpecializations = () => {
//         fetchDrSpecialization()
//             .then((res) => {
//                 setDrSpecialization(res);
//             })
//     }

//     const handleChange = (event) => {
//         const { name, value } = event.target;
//         setData({ ...data, [name]: value });
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         const password = data.password.trim();
//         const confirmPassword = data.confirmPassword.trim();
//         if (mobile.length < 10 || !/^\d+$/.test(mobile)) {
//             setIsError('Invalid mobile number');
//             return;
//         }
//         if (password === '' || confirmPassword === '') {
//             setIsError('Password fields cannot be empty');
//             return;
//         }

//         if (password !== confirmPassword) {
//             alert('Passwords do not match');
//             return;
//         }
//         if (specialization === '') {
//             setIsError('Select Specialization');
//             return;
//         }
//         const bodyData = {
//             specialization: specialization,
//             mobile: mobile,
//             password: password,
//             _id: _id
//         };
//         signUp(bodyData)
//             .then(response => {
//                 if (response.data.message) {
//                     setError('Sign up failed: ' + response.data.message);
//                 } else {
//                     const doctorId = response.data._id;
//                     navigate(`/newdoctor/${doctorId}/addnewdoctor`);
//                 }
//             })
//             .catch(err => {
//                 console.error('Sign-up error:', err);
//                 setError('An error occurred during sign-up');
//             });
//     };

//     return (
//         <>
//             <div className="col-md-12" align='left'>
//                 {error === true ? <div className="validation mb-2 ml-3">
//                     Mobile number already exist login to continue
//                 </div>
//                     : null}
//             </div>

//             <lable className="mb-2 font_weight">Enter MPIN</lable>
//             <div className="col-md-12">
//                 <MainInput
//                     type="password"
//                     name="password"
//                     maxLength={6}
//                     pattern="[+-]?\d+(?:[.,]\d+)?"
//                     onChange={handleChange}
//                     placeholder="New MPIN"
//                     required
//                 >
//                 </MainInput>
//             </div>

//             <lable className="mb-2 font_weight">Confirm MPIN</lable>
//             <div className="col-md-12">
//                 <MainInput
//                     type="password"
//                     name="confirmPassword"
//                     maxLength={6}
//                     pattern="[+-]?\d+(?:[.,]\d+)?"
//                     onChange={handleChange}
//                     placeholder="Confirm MPIN"
//                     required>
//                 </MainInput>
//             </div>
//             <lable className="mb-2 fontSize">Specialization</lable>
//             <div className="col-md-12 mb-2">
//                 <MainSelect
//                     name="specialization"
//                     className="form-control"
//                     value={specialization}
//                     onChange={(e) => setSpecialization(e.target.value)}>
//                     <option>Select specialization</option>
//                     {drspecialization ?
//                         <>
//                             {drspecialization && drspecialization.map((spe, index) => (
//                                 <option className="form-control" key={index}>{spe.specialization}</option>
//                             ))}
//                         </>
//                         : null}
//                 </MainSelect>
//             </div>
//             <div className="mt-2">
//                 <MainButtonInput onClick={handleSubmit}>Login</MainButtonInput>
//             </div>
//             {isError !== '' ? <div className="validation mt-3 ml-3">
//                 {isError}
//             </div>
//                 : null}
//         </>
//     )
// }

import { useState, useEffect } from "react";
import {
  Link,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { MainButtonInput } from "../../../mainComponent/mainButtonInput";
import { MainInput } from "../../../mainComponent/mainInput";
import { MainSelect } from "../../../mainComponent/mainSelect";
import AuthApi from "../../../services/AuthApi";
import { useRecoilState } from "recoil";
import { setDoctorId } from "../../../recoil/atom/setDoctorId";
import EducationalApi from "../../../services/EducationalApi";
import { Wrapper } from "../../../mainComponent/Wrapper";
import { MainNav } from "../../../mainComponent/mainNav";
import UserLinks from "../../Dashboard-card/partial/uselinks";
import { setHelperData } from "../../../recoil/atom/setHelperData";

export default function CreateForm() {
  //for show otp input
  const location = useLocation();
  const { mobile, loginData } = location.state || {};
  const [isError, setIsError] = useState("");
  const [error, setError] = useState(false);
  const [DoctorId] = useRecoilState(setDoctorId);
  const [drspecialization, setDrSpecialization] = useState(null);
  const [specialization, setSpecialization] = useState("");
  const [data, setData] = useState({
    password: "",
    confirmPassword: "",
  });
  const [helpersData, setHelpersData] = useRecoilState(setHelperData);
  const [doctorId] = useRecoilState(setDoctorId);
  const { signUp } = AuthApi();
  const { fetchDrSpecialization } = EducationalApi();
  const navigate = useNavigate();

  useEffect(() => {
    fetchSpecializations();
  }, []);

  const fetchSpecializations = () => {
    fetchDrSpecialization().then((res) => {
      setDrSpecialization(res);
    });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setData({ ...data, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const password = data.password.trim();
    const confirmPassword = data.confirmPassword.trim();
    if (mobile.length < 10 || !/^\d+$/.test(mobile)) {
      setIsError("Invalid mobile number");
      return;
    }
    if (password === "" || confirmPassword === "") {
      setIsError("Password fields cannot be empty");
      return;
    }

    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }
    if (specialization === "") {
      setIsError("Select Specialization");
      return;
    }
    const bodyData = {
      specialization: specialization,
      mobile: mobile,
      password: password,
      _id: loginData._id,
    };
    signUp(bodyData)
      .then((response) => {
        if (response.data.message) {
          setError("Sign up failed: " + response.data.message);
        } else {
          const doctorId = response.data._id;
          navigate(`/newdoctor/${doctorId}/addnewdoctor`);
        }
      })
      .catch((err) => {
        console.error("Sign-up error:", err);
        setError("An error occurred during sign-up");
      });
  };

  return (
    <Wrapper>
      <MainNav>
        <ul className="clearfix">
          <li>
            <Link to={`/newdoctor/${doctorId}/creatempin`}>
              <i className="arrow_back backArrow" title="back button"></i>
            </Link>
          </li>
          <li className="float-none" style={{ fontSize: "inherit" }}>
            Create Account
          </li>
        </ul>
      </MainNav>
      <div className="row ">
        <div className="width_16">
          <div className="dash row">
            <UserLinks
              doctorId={doctorId}
              helperId={helpersData._id}
              accessModule={helpersData.access_module}
            />
          </div>
        </div>
        <div className="width_84 common_box">
          <div className="container margin_60_35">
            <div id="login-2">
              <h5>Set MPIN </h5>
              <div className="col-md-12" align="left">
                {error === true ? (
                  <div className="validation mb-2 ml-3">
                    Mobile number already exist login to continue
                  </div>
                ) : null}
              </div>

              <lable className="font_weight ">Enter MPIN</lable>
              <div className="col-md-12 mt-1 mb-2">
                <MainInput
                  type="password"
                  name="password"
                  maxLength={6}
                  pattern="[+-]?\d+(?:[.,]\d+)?"
                  onChange={handleChange}
                  placeholder="New MPIN"
                  required
                ></MainInput>
              </div>

              <lable className="mb-2 font_weight">Confirm MPIN</lable>
              <div className="col-md-12 mt-1 mb-2">
                <MainInput
                  type="password"
                  name="confirmPassword"
                  maxLength={6}
                  pattern="[+-]?\d+(?:[.,]\d+)?"
                  onChange={handleChange}
                  placeholder="Confirm MPIN"
                  required
                ></MainInput>
              </div>
              <lable className="mb-2 font_weight">Specialization</lable>
              <div className="col-md-12 mt-1 mb-2">
                <MainSelect
                  name="specialization"
                  className="form-control"
                  value={specialization}
                  onChange={(e) => setSpecialization(e.target.value)}
                >
                  <option>Select specialization</option>
                  {drspecialization ? (
                    <>
                      {drspecialization &&
                        drspecialization.map((spe, index) => (
                          <option className="form-control" key={index}>
                            {spe.specialization}
                          </option>
                        ))}
                    </>
                  ) : null}
                </MainSelect>
              </div>
              <div className="mt-4">
                <MainButtonInput onClick={handleSubmit}>Login</MainButtonInput>
              </div>
              {isError !== "" ? (
                <div className="validation mt-3 ml-3">{isError}</div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <Outlet />
    </Wrapper>
  );
}
